<template>
  <!-- 服务质量分 -->
  <div id="qualityScore">
    <van-nav-bar title="服务分质量" :border="false" left-arrow @click-left="goLastPage" right-text="">
    </van-nav-bar>
    <ScoreCanvas />
    <!-- 扣分 -->
    <!-- <div class="deduction">
      <div class="publicDeduction" @click="goSubPage('deduct_score')">
        <svg t="1601278702739" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4132" width="18" height="18">
          <path d="M162.016 580.992L192.032 640q-31.008 30.016-32 64 4 64 102.496 111.008T512.032 864q151.008-2.016 249.504-48.992T864.032 704q-0.992-34.016-32-64l31.008-59.008q31.008 26.016 48 56.992T928.032 704q-4.992 99.008-123.008 160.512T512.032 928q-175.008-2.016-292.992-63.488T96.032 704q0-35.008 17.504-66.016t48.512-56.992z m0-192L192.032 448q-31.008 30.016-32 64 4 64 102.496 111.008T512.032 672q151.008-2.016 249.504-48.992T864.032 512q-0.992-34.016-32-64l31.008-59.008q31.008 26.016 48 56.992T928.032 512q-4.992 99.008-123.008 160.512T512.032 736q-175.008-2.016-292.992-63.488T96.032 512q0-35.008 17.504-66.016t48.512-56.992zM512 544q-175.008-2.016-292.992-63.488T96 320q4.992-99.008 123.008-160.512T512 96q175.008 2.016 292.992 63.488T928 320q-4.992 99.008-123.008 160.512T512 544z m0-64q151.008-2.016 249.504-48.992T864 320q-4-64-102.496-111.008T512 160q-151.008 2.016-249.504 48.992T160 320q4 64 102.496 111.008T512 480z" p-id="4133"></path>
        </svg>
        <span>扣分明细</span>
      </div>
      <div class="solid"></div>
      <div class="publicDeduction" @click="goSubPage('deduct_ratio')">
        <svg t="1601278615004" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3874" width="18" height="18">
          <path d="M448 68v64.992q-150.016 30.016-238.496 144T130.016 544q16 152 122.496 250.016T512 896.032q144-3.008 248-91.008t131.008-228.992h64q-30.016 178.016-162.496 284T480 958.048q-179.008-16.992-295.008-141.504T64 512.032q3.008-171.008 108.992-293.504T448 68.032z m128 28.992V448h351.008q-15.008-143.008-111.488-239.488t-239.488-111.488zM512 64v-31.008q98.016-6.016 188.512 27.488t160 103.008 103.008 160T991.008 512H512V64z" p-id="3875"></path>
        </svg>

        <span>扣率明细</span>
      </div>
    </div> -->
    <!-- 详细信息 -->
    <div class="detailedList">
      <div class="detailedInfo" @click="popup(0)">
        <svg t="1601280427926" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15322" width="40" height="40">
          <path d="M512 13.032727A510.138182 510.138182 0 0 0 90.530909 809.658182a35.141818 35.141818 0 0 0 28.858182 15.127273 33.978182 33.978182 0 0 0 20.247273-6.05091 34.676364 34.676364 0 0 0 9.309091-48.407272 438.923636 438.923636 0 0 1-75.17091-228.538182h56.785455a37.701818 37.701818 0 0 0 0-75.170909H76.334545A437.992727 437.992727 0 0 1 162.909091 256l32.581818 32.581818a37.701818 37.701818 0 0 0 53.294546-53.061818L214.109091 200.378182a439.156364 439.156364 0 0 1 263.214545-116.363637 34.443636 34.443636 0 0 0-2.094545 11.869091v59.345455a37.701818 37.701818 0 0 0 75.170909 0V96.349091a40.96 40.96 0 0 0-2.094545-11.869091A437.992727 437.992727 0 0 1 809.890909 199.214545l-36.305454 36.305455a37.701818 37.701818 0 0 0 53.294545 53.061818L861.090909 254.603636a436.596364 436.596364 0 0 1 88.203636 212.014546h-55.854545a37.701818 37.701818 0 0 0 0 75.170909h58.88a437.294545 437.294545 0 0 1-72.610909 224.814545 34.909091 34.909091 0 0 0 58.181818 38.632728A510.370909 510.370909 0 0 0 512 13.032727z" p-id="15323" fill="#686868"></path>
          <path d="M608.814545 377.250909L498.036364 488.727273a51.432727 51.432727 0 0 0-8.610909 0 62.370909 62.370909 0 1 0 62.370909 62.138182 46.545455 46.545455 0 0 0 0-7.912728l111.010909-111.010909a37.469091 37.469091 0 0 0-53.061818-53.061818z" p-id="15324" fill="#686868"></path>
        </svg>
        <p>预约及时率</p>
        <p>100%</p>
      </div>
      <div class="detailedInfo" @click="popup(1)">
        <svg t="1601279489313" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6208" width="40" height="40">
          <path d="M929.28 189.44l-417.28 417.28-158.208-158.208-53.248 53.248 184.832 184.832 26.624 25.6 26.624-25.6 443.904-443.904-53.248-53.248z m-417.28-158.72c-266.24 0-480.768 214.528-480.768 480.768s214.528 480.768 480.768 480.768 480.768-214.528 480.768-480.768c0-51.712-7.168-103.424-25.6-151.552l-59.904 58.88c7.168 29.696 11.776 59.392 11.776 92.672 0 225.792-181.248 407.04-407.04 407.04s-407.04-181.248-407.04-407.04 181.248-407.04 407.04-407.04c111.104 0 210.432 44.032 281.088 114.688L844.8 167.424c-84.992-84.992-203.264-136.704-332.8-136.704z" p-id="6209" fill="#686868"></path>
        </svg>
        <p>预约达成率</p>
        <p>100%</p>
      </div>
      <div class="detailedInfo" @click="popup(2)">
        <svg t="1601280694773" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="913" width="40" height="40">
          <path d="M 851.412 806.16 l -90.696 90.32 l -67.696 -67.696 l 90.508 -90.508 c 87.48 -87.48 87.48 -229.308 0 -316.784 c -87.48 -87.48 -229.304 -87.48 -316.784 0 l -90.528 90.528 l -67.88 -67.88 l 90.528 -90.532 c 124.968 -124.968 327.58 -124.968 452.548 0 c 124.968 124.968 124.968 327.58 0 452.548 Z" fill="#686868" p-id="914"></path>
          <path d="M 172.588 217.84 l 90.696 -90.32 l 67.696 67.696 l -90.508 90.508 c -87.48 87.48 -87.48 229.308 0 316.784 c 87.48 87.48 229.304 87.48 316.784 0 l 90.528 -90.528 l 67.88 67.88 l -90.528 90.532 c -124.968 124.968 -327.58 124.968 -452.548 0 c -124.968 -124.968 -124.968 -327.58 0 -452.548 Z" fill="#686868" p-id="915"></path>
        </svg>
        <p>核销率</p>
        <p>100%</p>
      </div>
      <div class="detailedInfo" @click="popup(3)">
        <svg t="1601279822440" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13373" width="40" height="40">
          <path d="M956.258153 102.763478c-1.602498-18.972097-16.718777-33.983999-35.69906-35.45449-245.245564-19.079544-421.889703 99.614765-531.024286 249.522983-60.316737-19.761066-125.069507-12.719696-184.119391 20.551058-56.879452 32.039717-105.327884 86.024236-136.417973 152.010089-7.122211 15.111163-3.784186 33.087583 8.292873 44.633546 12.07706 11.550057 30.189579 14.077623 44.958958 6.282077 62.190411-32.788777 132.213207-26.615171 174.260859 15.377222L467.734844 726.724433c0.309038 0.331551 0.523933 0.713244 0.847298 1.035586 42.009789 41.964764 48.193629 111.87602 15.386432 173.958984-7.804756 14.770402-5.291516 32.878828 6.244214 44.966121 7.501858 7.855922 17.71957 12.023848 28.108175 12.023848 5.590322 0 11.228739-1.204431 16.520255-3.689019 66.049299-31.058366 120.088052-79.456656 152.164608-136.276756 33.506115-59.353806 40.470737-124.474966 20.247136-185.05674 44.042075-31.610952 83.466993-67.240427 116.585275-105.894795C925.505755 409.124981 970.06153 266.125103 956.258153 102.763478zM195.549721 441.832917c41.322128-41.259706 94.360088-65.905012 149.610436-56.208163-15.216563 26.822902-28.426423 54.078663-39.702234 81.269955C272.395924 449.098391 234.561223 440.446337 195.549721 441.832917zM582.454632 828.592518c1.366114-39.392172-7.458879-77.511351-25.589818-110.74629 28.201296-11.960403 55.491849-25.467021 81.675184-40.294728C648.995117 733.307362 624.206548 786.915303 582.454632 828.592518zM505.637082 654.779867 368.719736 518.009877c68.61882-183.799096 239.044328-380.192022 512.044002-374.880039C889.938702 468.467531 621.320824 609.381911 505.637082 654.779867zM756.591671 267.765463c11.750625 11.754718 18.450211 28.066219 18.450211 44.672432 0 16.60519-6.699586 32.82664-18.450211 44.576241-11.749602 11.750625-28.065196 18.545378-44.670385 18.545378-16.60519 0-32.8205-6.794753-44.570101-18.545378-11.749602-11.750625-18.549471-27.972075-18.549471-44.576241 0-16.606213 6.79987-32.917714 18.549471-44.672432 11.649318-11.750625 27.964912-18.450211 44.570101-18.450211C728.527498 249.315252 744.843092 256.014838 756.591671 267.765463zM209.751165 671.104671c-44.641733 44.600801-46.391587 133.923152-46.291302 151.249773 0.127913 21.275559 17.339924 39.245839 38.615483 39.245839 0.38374 0 0.801249 0 1.25662 0 19.999496 0 105.826234-3.267417 149.471266-46.858214 27.557636-27.53103 33.343409-55.616692 33.343409-74.066903-0.005117-25.856901-11.104919-51.343365-31.270191-71.486124C305.714773 620.088764 245.193375 635.703393 209.751165 671.104671zM297.900807 759.148913c-9.564843 9.55461-31.048133 16.050558-52.977585 19.753903 3.797489-22.115694 10.42135-43.533492 19.730367-52.832276 6.344498-6.335289 12.389168-10.574846 18.942421-10.574846 5.039783 0 10.379395 2.508123 16.382109 8.501628 5.3918 5.386684 8.482185 11.351536 8.482185 16.367783C308.460304 747.176231 302.713416 754.341421 297.900807 759.148913z" p-id="13374" fill="#686868"></path>
        </svg>
        <p>48小时完成率</p>
        <p>100%</p>
      </div>
      <div class="detailedInfo" @click="popup(4)">
        <svg t="1601279860337" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14399" width="40" height="40">
          <path d="M512.141 962.492c-248.6 0-450.132-201.532-450.132-450.132S263.542 62.228 512.141 62.228 962.273 263.76 962.273 512.36 760.741 962.492 512.141 962.492z m0-818.422c-203.402 0-368.29 164.887-368.29 368.29s164.887 368.29 368.29 368.29 368.29-164.887 368.29-368.29-164.887-368.29-368.29-368.29z m163.685 409.211h-93.194c-14.175 24.36-40.275 40.921-70.491 40.921-45.201 0-81.842-36.641-81.842-81.842 0-30.216 16.561-56.316 40.921-70.491V266.833c0-22.601 18.32-40.921 40.921-40.921s40.921 18.32 40.921 40.921v175.036a82.974 82.974 0 0 1 29.741 29.57h93.022c22.601 0 40.921 18.32 40.921 40.921 0.001 22.601-18.32 40.921-40.92 40.921z" p-id="14400" fill="#686868"></path>
        </svg>
        <p>按时按成率</p>
        <p>100%</p>
      </div>
    </div>
  </div>
</template>
<script>
import TopBar from "@/components/home/TopBar.vue";
import ScoreCanvas from "@/components/Mine/ScoreCanvas.vue";
export default {
  components: {
    TopBar,
    ScoreCanvas,
  },
  data() {
    return {
      popupDate: [
        {
          message: `<p>预约及时率：预约及时指的是指派时已到货的订单，以指派时间为准2小时内预约；指派时还未到货的订单，以实际到货时间开始2小时内预约。</p>\n<P>若在非常规时间指派／到货，为避免打扰客户，按如下规则完成预约，将不扣除预约及时率。</P>\n<P>西藏、新疆、青海地区在晚上22:00~次日10:00指派／到货，可次日上午12:00前预约客户（即10点后的2小时内）。其他地区在晚上20:00~次日8:00指派／到货，可次日10:00前预约客户。</P>`,
          title: `预约及及时率`,
          index: 0,
        },
        {
          message: `<p>预约达成率：达成率指的是师傅已预约上门时间区间内抵达客户家完成上门签到（地理位置签到）</P>`,
          title: `预约及达成率`,
          index: 1,
        },
        {
          message: `<p>核销指的是师傅根据订单完成喵师傅／亿师傅核销操作，并上传核销结果截图至接单易。（注：需要核销的订单不完成核销不能继续操作完成服务完工）</P>`,
          title: `核销率`,
          index: 2,
        },
        {
          message: `<p>预约达成率：达成率指的是师傅已预约上门时间区间内抵达客户家完成上门签到（地理位置签到）</P>`,
          title: `48小时完成率`,
          index: 3,
        },
        {
          message: `<p>48小时完成率：48小时服务完成指的是配送类订单按照要求在订单指派后（物流已到货）48小时内操作服务完成。非配送类订单按照要求订单在指派您之后48小时内操作服务完成。</P>`,
          title: `按时完成率`,
          index: 4,
        },
      ],
    };
  },
  created() {
    this.getScore();
  },
  methods: {
    getScore() {
      this.$http.get("/api/v2/worker/profile/score").then((res) => {
        console.log(res);
      });
    },
    toLastIndex() {
      this.$router.go(-1);
    },
    popup(index) {
      this.$dialog.alert({
        message: this.popupDate[index].message,
        title: this.popupDate[index].title,
        messageAlign: "left",
        confirmButtonText: "我知道了",
      });
    },
  },
};
</script>
<style lang="less">
#qualityScore {
  .deduction {
    display: flex;
    .publicDeduction {
      flex: 1;
      height: 6rem;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.6rem;
      color: #505050;
      span {
        margin-left: 1rem;
      }
    }
    .solid {
      width: 0.1rem;
    }
  }
  .detailedList {
    display: flex;
    flex-wrap: wrap;
    width: 100%;   
    margin: 1rem 0;
    padding: 1.5rem;
    box-sizing: border-box;
    .detailedInfo {
      width: calc(100% / 3);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 1.6rem;
      margin: 1rem 0;
      .icon {
        margin-bottom: 1rem;
      }
      p {
        margin: 0.5rem 0;
      }
    }
  }
}
</style>>